import React, { Component } from 'react';
import _ from 'lodash';

import CamdetectCamerasTable from '../components/CamdetectCamerasTable';
import CamdetectParkinglocationsSelect from '../components/CamdetectParkinglocationsSelect';
import CamdetectCamerasForm from '../components/CamdetectCamerasForm';

import CamdetectCamerasModel from '../components/CamdetectCamerasModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, Switch, message } from 'antd';

class CamdetectCamerasScreen extends Component {

    state = {
        autoReload: (localStorage.getItem('table_autoReload') !== undefined && localStorage.getItem('table_autoReload') == 'true') ? true : false,
        dataLoading: false,
        dataAll: [],
        data: [],
        searchedTextValue: "",
        camdetectCamerasFormModalVisible: false,
        camdetectParkinglocationId: null
    }

    intervalId = null;

    componentWillMount() {
        this.loadData(this.state.camdetectParkinglocationId);

        // Checking auto reload data
        this.intervalId = setInterval(() => {
            if (this.state.autoReload && this.state.camdetectParkinglocationId) {
                this.loadData(this.state.camdetectParkinglocationId);
            }
        }, 30000);
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    loadData(camdetectParkinglocationId) {
        this.setState({
            dataLoading: true
        });
        CamdetectCamerasModel.getAll(camdetectParkinglocationId)
            .then(data => {
                this.setState({
                    dataLoading: false,
                    dataAll: data,
                    data: data
                });
            })
            .catch(() => {
                message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.');
                this.setState({
                    dataLoading: false,
                });
            });
    }

    render() {
        return (
            <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
                <div style={{ padding: 24, background: '#fff' }}>
                    <h2>Kamerová detekce - Kamery</h2>
                    <div style={{ marginBottom: '20px' }}>
                        <Row>
                            <Col span={16}>
                                <CamdetectParkinglocationsSelect
                                    allowClear={true}
                                    onChange={(value) => {
                                        this.loadData(value);
                                        this.setState({ searchedTextValue: "", camdetectParkinglocationId: value });
                                    }}
                                    style={{ width: 300 }} />
                                {' '}
                                <Input.Search
                                    placeholder="Najít název kamery"
                                    value={this.state.searchedTextValue}
                                    onSearch={(searchText) => {
                                        const dataAll = this.state.dataAll;
                                        this.setState({
                                            data: _.filter(dataAll, (d) => {
                                                return d.cameraName.toString().startsWith(searchText);
                                            })
                                        });
                                    }}
                                    onChange={(e) => {
                                        this.setState({
                                            searchedTextValue: e.target.value
                                        })
                                    }}
                                    style={{ width: 300 }} />
                            </Col>
                            <Col span={8} style={{ textAlign: 'right' }}>
                                <Switch
                                    checked={this.state.autoReload}
                                    onChange={(checked) => {
                                        localStorage.setItem('table_autoReload', checked);
                                        this.setState({
                                            autoReload: checked
                                        });
                                    }} /> Automatická obnova
                <Button type="default" onClick={() => { this.loadData(this.state.camdetectParkinglocationId) }} style={{ marginRight: 10, marginLeft: 15 }}><Icon type="sync" /></Button>
                                {UserModel.isInRoles(['ADMIN', 'CAMDETECT_CAMERAS_WRITE'])
                                    ? <Button type="default" onClick={() => { this.setState({ camdetectCamerasFormModalVisible: true }) }}>Nová kamera</Button>
                                    : null}
                            </Col>
                        </Row>
                    </div>
                    <CamdetectCamerasForm
                        type="modal"
                        modalVisible={this.state.camdetectCamerasFormModalVisible}
                        onModalCancel={(form) => {
                            form.resetFields();
                            this.setState({ camdetectCamerasFormModalVisible: false })
                        }}
                        onSuccess={(form, values) => {
                            CamdetectCamerasModel.create(values)
                                .then(() => {
                                    form.resetFields();
                                    this.loadData(this.state.camdetectParkinglocationId);
                                })
                                .catch((err) => {
                                    message.warning('Data se nepodařilo uložit. Prosím kontaktujte správce systému!');
                                });
                        }} />
                    <CamdetectCamerasTable
                        data={this.state.data}
                        loading={this.state.dataLoading}
                        onAnyFormSuccess={() => {
                            this.loadData(this.state.camdetectParkinglocationId);
                        }}
                        onRemoveRow={(id) => {
                            CamdetectCamerasModel.remove(id)
                                .then(() => {
                                    this.loadData(this.state.camdetectParkinglocationId);
                                })
                                .catch((err) => {
                                    message.warning('Senzor se nepodařilo smazat. Prosím kontaktujte správce systému!');
                                });
                        }} />
                </div>
            </Layout.Content>
        );
    }
}

export default CamdetectCamerasScreen;



// WEBPACK FOOTER //
// ./src/screens/CamdetectCamerasScreen.js